import React from 'react';
import Container from '../../../../components/Container';
import styles from './Desktop.module.css';
import Popup from '../../../../components/Popup/Popup';
import PopupContent from '../../../../components/Popup/PopupContent';
import Content from '../../../../components/Content';
import { oneDineLogo } from '../../../../assets/images';
import constants from '../../../../globalization';
import { Paper, Typography, TextField, Box, IconButton } from '@material-ui/core';
import { ArrowForwardOutlined } from '@material-ui/icons';
import useStyles from './useStyles';

export default function Desktop(props) {
  const classes = useStyles();
  const { popup, activationKey, activateDevice, handleChange, isActivateArrowDisabled, closePopup } = props;

  const getPopupStyle = () => {
    let popupStyle = {};
    if (popup && popup.type === "spinner") {
      popupStyle = { width: "60%" };
    } else if (popup && popup.type === "popup") {
      popupStyle = { width: "30%" };
    }
    return popupStyle;
  };

  return (
    <Container style={styles.container}>
      <Popup visible={!!popup} popupStyle={getPopupStyle()} closePopup={closePopup}>
        <PopupContent {...popup} />
      </Popup>
      <Content style={styles.content}>
        <Paper className={classes.paper}>
          <img src={oneDineLogo} className={classes.image} alt="logo" />
          <Typography variant='h6' className={classes.text}>{constants.activationCode}</Typography>
          <Box className={classes.box}>
            <TextField
              id='outlined-basic'
              label=''
              variant='outlined'
              size='medium'
              fullWidth
              value={activationKey}
              onChange={handleChange}
            />
            <IconButton
              size={'medium'}
              color={'primary'}
              disabled={isActivateArrowDisabled()}
              onClick={activateDevice}
            >
              <ArrowForwardOutlined fontSize={'large'} />
            </IconButton>
          </Box>
        </Paper>
      </Content>
    </Container>
  );
}
